module.exports = __webpack_public_path__ + "static/media/truck_white.ad1b1f97.png";